import { render } from "./SupermercadosAtivosCards.vue?vue&type=template&id=4a9cf375&scoped=true"
import script from "./SupermercadosAtivosCards.vue?vue&type=script&lang=js"
export * from "./SupermercadosAtivosCards.vue?vue&type=script&lang=js"

import "./SupermercadosAtivosCards.vue?vue&type=style&index=0&id=4a9cf375&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9cf375"]])

export default __exports__